<template>
  <div class="profile">
    <p class="text">内容をご確認の上、ご登録ください。</p>
    <div class="image preview">
      <img class="preview__image" :src="profileData.photoURL" />
    </div>
    <dl class="profile__confirm">
      <div class="underline" v-if="profileData.email">
        <dt class="profile__confirm__dt">メールアドレス</dt>
        <dd class="profile__confirm__dd">{{ profileData.email }}</dd>
      </div>
      <div class="underline">
        <dt class="profile__confirm__dt">ニックネーム</dt>
        <dd class="profile__confirm__dd">{{ profileData.nickname }}</dd>
      </div>
      <div class="underline">
        <dt class="profile__confirm__dt">生年月日</dt>
        <dd class="profile__confirm__dd">{{ birthDateString }}</dd>
      </div>
    </dl>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'RegistrationConfirmation',
  props: {
    profileData: Object,
  },
  computed: {
    birthDateString() {
      return moment(this.profileData.birthDate).format('YYYY-MM-DD');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/signup-email.scss';
</style>
